var cof = require('./_cof');
module.exports = function(it, msg){
  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
  return +it;
};


/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/_a-number-value.js
 **/